export const CMS_ROLES = {
  USER: "User",
  RESTAURANT: "Restaurant",
  DRIVER: "Driver",
};

export const CMS_ROLE_TABS = [
  { id: "driver", label: "Driver", role: CMS_ROLES.DRIVER },
  { id: "customer", label: "Customer", role: CMS_ROLES.USER },
  { id: "restaurant", label: "Restaurant", role: CMS_ROLES.RESTAURANT },
];

export const CMS_CONTENT = {
  ABOUT_US: {
    type: "about_us",
    title: "About Us",
    label: "About Us",
  },
  TERM_AND_CONDITION: {
    type: "term_and_condition",
    title: "Terms And Conditions",
    label: "Terms And Conditions",
  },
  PRIVACY_POLICY: {
    type: "privacy_policy",
    title: "Privacy Policy",
    label: "Privacy Policy",
  },
};

/** Single About Us — always stored under Restaurant role */
export const CMS_ABOUT_US_TAB = CMS_CONTENT.ABOUT_US;
export const CMS_ABOUT_US_ROLE = CMS_ROLES.RESTAURANT;

/** Terms & Privacy — per Driver / Customer / Restaurant */
export const CMS_ROLE_CONTENT_TABS = [
  CMS_CONTENT.TERM_AND_CONDITION,
  CMS_CONTENT.PRIVACY_POLICY,
];

export const CMS_FAQ_TAB = {
  id: "faq",
  label: "FAQ",
};

export const getCmsContentByType = (contentType) =>
  Object.values(CMS_CONTENT).find((item) => item.type === contentType);

export const buildCmsQueryParams = (role, contentType) => ({
  role,
  type: contentType,
});

export const buildCmsPayload = (role, contentType, description) => {
  const config = getCmsContentByType(contentType);
  return {
    type: contentType,
    title: config?.title || contentType,
    description,
    role,
  };
};

/** POST /admin/addFaq — role: User | Restaurant | Driver */
export const buildFaqPayload = (role, question, answer) => ({
  role,
  question,
  answer,
});

/** PUT /admin/updateFaq/:faqId */
export const buildFaqUpdatePayload = (question, answer) => ({
  question,
  answer,
});
